// extracted by mini-css-extract-plugin
module.exports = {"userPage":"UserPage_userPage__t4MW7","user":"UserPage_user__2BqjP","tabs":"UserPage_tabs__2Td6P","general":"UserPage_general__16dYh","col":"UserPage_col__3_PQg"};